import IEnviarDocumentoOnboardingRequest from '../entities/IEnviarDocumentoOnboardingRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IEnviarDocumentoOnboarding {
  execute(data: IEnviarDocumentoOnboardingRequest): Promise<void>
}

export default class EnviarDocumentoOnboardingImpl
  implements IEnviarDocumentoOnboarding
{
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(data: IEnviarDocumentoOnboardingRequest): Promise<void> {
    return this.pagamentosRepository.enviarDocumentoOnboarding(data)
  }
}
